export default __webpack_public_path__ + "static/media/1-1-3.83aba1e9.jpg";